export function parallax($element) {
	window.gsap.timeline({
		defaults: { ease: 'none' },
		scrollTrigger: {
			trigger: $element,
			start: 'top top',
			end: 'bottom top',
			scrub: true,
			onUpdate: self => {
				$element.css('--parallax-progress', self.progress);
			},
		},
	})
}

export function reveal(element) {
	window.ScrollTrigger.create({
		trigger: element,
		start: 'top bottom-=20%',
		end: 'top bottom-=20%',
		onEnter: () => {
			$(element).prop('inert', false);
		},
		onLeaveBack: () => {
			$(element).prop('inert', true);
		},
	})
}
